export default __webpack_public_path__ + "static/hu-2890cfb53291857df11135ad953c6380.svg";